// extracted by mini-css-extract-plugin
module.exports = {"triggerButton":"UserInfoTrigger_triggerButton__2HCGa","contactIcon":"UserInfoTrigger_contactIcon__1Z48S","arrowIcon":"UserInfoTrigger_arrowIcon__3GfXm"};